/* ============================================================================
 * SarvaSuite — login page composition
 * ----------------------------------------------------------------------------
 * Frappe's login page is a bare centred card. This turns it into a split
 * screen: product framing on the left, the sign-in form on the right.
 *
 * Copy is deliberately factual — what the product does, not invented social
 * proof or customer counts.
 *
 * Runs only on the auth routes, and only ever ADDS a sibling panel; the login
 * form itself is untouched, so Frappe's auth flow is unaffected.
 *
 * License: MIT (SarvaSuite, Inc.)
 * ========================================================================== */
(function () {
	"use strict";

	var AUTH_PATHS = ["/login", "/update-password", "/signup"];

	function isAuthPage() {
		var p = window.location.pathname.replace(/\/+$/, "") || "/";
		for (var i = 0; i < AUTH_PATHS.length; i++) {
			if (p === AUTH_PATHS[i] || p.indexOf(AUTH_PATHS[i] + "/") === 0) return true;
		}
		return false;
	}

	var POINTS = [
		["CRM and pipeline", "Leads, deals and conversations in one timeline."],
		["Quotes to cash", "Quotations, orders, invoices and payments that stay in step."],
		["Stock, projects, support", "The rest of the business, on the same records."],
	];

	function brandPanel(logoSrc) {
		var aside = document.createElement("aside");
		aside.className = "ss-login-brand";

		var points = POINTS.map(function (p) {
			return (
				'<li><span class="ss-tick">&#10003;</span><span><b>' +
				p[0] + "</b> &mdash; " + p[1] + "</span></li>"
			);
		}).join("");

		aside.innerHTML =
			'<div class="ss-brand-mark">' +
			(logoSrc ? '<img src="' + logoSrc + '" alt="">' : "") +
			"<span>SarvaSuite</span></div>" +
			'<div class="ss-brand-copy">' +
			'<div class="ss-brand-eyebrow">SarvaERP</div>' +
			'<h1 class="ss-brand-headline">Run the whole business from one place.</h1>' +
			'<p class="ss-brand-sub">Sales, inventory, accounting, projects and support on a single set of records — so nothing has to be re-entered, reconciled or chased across tools.</p>' +
			'<ul class="ss-brand-points">' + points + "</ul>" +
			"</div>" +
			'<div class="ss-brand-foot"><span>&copy; ' + new Date().getFullYear() +
			" SarvaSuite</span><span>Secure sign-in</span></div>";

		return aside;
	}

	function enhance() {
		if (!isAuthPage()) return;

		var card = document.querySelector(".login-content.page-card") || document.querySelector(".page-card");
		if (!card || document.querySelector(".ss-login-brand")) return;

		document.body.classList.add("ss-login");

		var logo = document.querySelector(".page-card-head .app-logo");
		var panel = brandPanel(logo ? logo.getAttribute("src") : null);

		// The auth section holds several siblings — .page-card-head sits BESIDE
		// the card, not inside it. Move every existing child into one wrapper so
		// the grid ends up with exactly two columns.
		var section = card.parentElement;
		var formSide = document.createElement("div");
		formSide.className = "ss-login-form-side";

		while (section.firstChild) {
			formSide.appendChild(section.firstChild);
		}

		section.classList.add("ss-login-grid");
		section.appendChild(panel);
		section.appendChild(formSide);

		// A short line under the heading, so the form side is not just inputs.
		// .page-card-head is a sibling of the card, so search the wrapper.
		var head = formSide.querySelector(".page-card-head");
		if (head && !head.querySelector(".ss-form-sub")) {
			var sub = document.createElement("div");
			sub.className = "ss-form-sub";
			sub.textContent = "Sign in to continue to your workspace.";
			head.appendChild(sub);
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", enhance);
	} else {
		enhance();
	}
})();
